<div class="project-card px-5 py-3">
  <img src="{{project.img}}" class="round-img" [ngClass]="project.pixel? 'pixelated' : ''">
  <h3 class="title mb-0">{{project.title}}</h3>
  <p *ngIf="project.status">{{project.status}}</p>
  <h6 class="description">{{project.description}}</h6>
  <a *ngIf="project.url" href="{{project.url}}" class="learn-more">Learn More</a>
  <a *ngIf="project.routerLink" routerLink="{{project.routerLink}}" class="learn-more">Learn More</a>
  <a *ngIf="project.loadurl" href="{{project.loadurl}}" class="download"><i class="fas fa-file-download"></i> Download</a>
</div>
